// React
import PropTypes from "prop-types";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useRef, useState } from "react";
import { formatDateARG } from "utils/formatters";
import { makeNiceText } from "utils/formatters";
import clienteIcon from "assets/images/icons/cliente.png";
import pedido_pendiente from "assets/images/icons/pedido_pendiente.png";
import pedido_listo from "assets/images/icons/pedido_listo.png";
import pedido_preparacion from "assets/images/icons/pedido_preparacion.png";
import pedido_reservado from "assets/images/icons/pedido_reservado.png";
import calendarioIcon from "assets/images/icons/calendario.png";
import comentarioIcon from "assets/images/icons/comentario.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", xxl: "60%" },
  overflow: "visible",
};

export default function ModalDetalles({ open, handleClose, item }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox pb={3}>
            {/* Header */}
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={0}>
              <SoftTypography variant="h6" fontWeight="bold">
                Detalles del pedido
              </SoftTypography>
              <Tooltip title="Cerrar" placement="top">
                <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                  close
                </Icon>
              </Tooltip>
            </SoftBox>
            <SoftBox px={3} mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        component="img"
                        src={clienteIcon}
                        alt="Cliente"
                        width="100px"
                        p={3}
                        sx={{
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      />
                      <SoftTypography variant="caption" fontWeight="bold">
                        Cliente
                      </SoftTypography>
                      <SoftTypography variant="body2" fontWeight="bold">
                        {`${item?.cliente?.nombre ?? "Particular"} ${
                          item?.cliente?.apellido ?? ""
                        }`}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        component="img"
                        src={
                          item?.estado === "PAGO EN REVISIÓN"	
                            ? pedido_pendiente
                            : item?.estado === "RESERVADO"
                            ? pedido_reservado
                            : item?.estado === "EN PREPARACIÓN"
                            ? pedido_preparacion
                            : item?.estado === "CERRADO"
                            ? pedido_listo
                            : clienteIcon
                        }
                        alt="Estado"
                        width="100px"
                        p={3}
                        sx={{
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      />
                      <SoftTypography variant="caption" fontWeight="bold">
                        Estado
                      </SoftTypography>
                      <SoftTypography variant="body2" fontWeight="bold">
                        {makeNiceText(item?.estado)}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        component="img"
                        src={calendarioIcon}
                        alt="Fecha"
                        width="100px"
                        p={3}
                        sx={{
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      />
                      <SoftTypography variant="caption" fontWeight="bold">
                        Fecha
                      </SoftTypography>
                      <SoftTypography variant="body2" fontWeight="bold">
                        {item?.fechaPedido ? formatDateARG(item?.fechaPedido) : "Sin fecha"}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        component="img"
                        src={comentarioIcon}
                        alt="Comentario"
                        width="100px"
                        p={3}
                        sx={{
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      />
                      <SoftTypography variant="caption" fontWeight="bold">
                        Comentario
                      </SoftTypography>
                      <SoftTypography variant="body2" fontWeight="bold">
                        {makeNiceText(item?.comentario) || "Sin comentario"}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </SoftBox>

            <SoftBox px={3} mt={3} sx={{ width: "100%", maxHeight: "60vh", overflowY: "auto" }}>
              {item?.detalles?.map((detalle, index) => (
                <Card
                  key={index}
                  sx={{
                    mb: 2,
                    p: 2,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: index % 2 === 0 ? "grey.100" : "white",
                    // boxShadow: 1,
                  }}
                >
                  <SoftTypography variant="h1">🍽️</SoftTypography>
                  <SoftBox ml={2} display="flex" flexDirection="column">
                    <SoftTypography variant="h6" color="primary" fontWeight="bold">
                      {detalle?.producto?.nombre}
                    </SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Cantidad: {detalle?.cantidad}
                    </SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Precio unitario: ${detalle?.precio}
                    </SoftTypography>
                    {detalle?.comentario && (
                      <SoftTypography variant="caption" fontWeight="bold" mt={1}>
                        Comentario: {detalle?.comentario}
                      </SoftTypography>
                    )}
                  </SoftBox>
                </Card>
              ))}
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalDetalles.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};
